module.exports = __webpack_public_path__ + "img/1_no_poverty_color.4d0752ce.svg";